import useStore from '.';

export function getStore() {
  return useStore();
}

export function test() {}
